import { render, staticRenderFns } from "./ScrollScores.vue?vue&type=template&id=0e0feb7a&scoped=true"
import script from "./ScrollScores.vue?vue&type=script&lang=js"
export * from "./ScrollScores.vue?vue&type=script&lang=js"
import style0 from "./ScrollScores.vue?vue&type=style&index=0&id=0e0feb7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0feb7a",
  null
  
)

export default component.exports